import * as React from "react";

var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function SvgZa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-za",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M-71.9 0h682.7v512H-71.9z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "translate(67.4) scale(.93748)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-71.9 407.8V104.4L154 256.1-72 407.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000c8a",
    d: "m82.2 512.1 253.6-170.6H696V512H82.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1392d",
    d: "M66 0h630v170.8H335.7S69.3-1.7 66 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb915",
    d: "M-71.9 64v40.4L154 256-72 407.8v40.3l284.5-192L-72 64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007847",
    d: "M-71.9 64V0h95l301.2 204h371.8v104.2H324.3L23 512h-94.9v-63.9l284.4-192L-71.8 64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23 0h59.2l253.6 170.7H696V204H324.3L23 .1zm0 512.1h59.2l253.6-170.6H696v-33.2H324.3L23 512z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZa);
export default ForwardRef;
export { ForwardRef as ReactComponent };